import { IItemAttributesMapping } from '../../interfaces/iitem-attributes-mapping';
import { Item } from '../item';
import { ItemAttribute } from '../item-attribute';

export class ItemAttributesMappingBase {
  ItemAttributeMappingId: number;
  ItemAttributeId: number;
  ItemId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ItemAttribute?: ItemAttribute;
  Item?: Item;

  constructor(item?: IItemAttributesMapping) {
    if (item) {

      this.ItemAttributeMappingId = item.ItemAttributeMappingId;
      this.ItemAttributeId = item.ItemAttributeId;
      this.ItemId = item.ItemId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ItemAttribute = new ItemAttribute(item.ItemAttribute);
      this.Item = new Item(item.Item);
    }
  }
}